const _domain = {
    31: 'https://www.yolo247.live',
    32: 'https://www.yolo247club.com',
    33: 'https://m.iw247.com',
    34: 'https://www.betdaily.club',
    39: 'https://www.fomo7.co',
    40: 'https://www.fomo7.xyz',
    46: 'https://www.fun88.site',
    47: 'https://www.fun88.live',
    61:'https://www.yolo247.io'
}
const _mailid = {
    31: 'support@yolo247.live',
    32: 'support@yolo247club.com',
    33: 'support@iw247.com',
    34: 'support@betdaily.club',
    39: 'support@fomo7.co',
    40: 'support@fomo7.xyz',
    46: 'support@fun88.site',
    47: 'support@fun88.live',
    61:'support@yolo247.io'
}

export function getDamain(brandId) {
    let domainURL = _domain[brandId] || '';
    return domainURL;
}

export function getMailId(brandId) {
    let mailId = _mailid[brandId] || '';
    return mailId;
}

export function filterGameData(data: any, brand: any) {
    //if Data is not array, return the original data
    if (!Array.isArray(data)) return data;

    //Provider name must be in Lowercase 
    let exclProvider = []

    if (brand === 61) {
        exclProvider = ['supernowa', 'ag', 'indialottery', 'winfinity'];
    }

    if (exclProvider.length > 0) {
        let filtereddata = data.filter(elm => {
            const provider = (elm.type || '').toLocaleLowerCase();
            if (!exclProvider.includes(provider)) {
                return elm;
            }
        })

        return filtereddata

    }
    
    return data

    //exclude the Provider from the given lists

}